// utils
import { axiosServerData, NetsuiteInstanceProps } from 'src/utils/axios'

// ----------------------------------------------------------------------

const param = {firstEndPoint: 'product'} as NetsuiteInstanceProps

const initParam = () => {
  param.data = undefined
  param.endUrl = ''
  param.headers = {}
}
const getProductsByPage = (idUser: string, config: string, page=1) => {
  initParam()
  param.method = 'get'
  param.idUser = idUser
  param.endUrl = `?page=${page}&limit=10000`
  param.lastEndPoint = 'list'
  param.headers = { config }
  return axiosServerData(param)
}
const getOneProduct = async (idUser: string, config: string, id: string) => {
  initParam();
  param.method = 'get';
  param.idUser = idUser;
  param.endUrl = `/${id}`;
  param.lastEndPoint = 'netsuite';
  param.headers = { config };
  return axiosServerData(param);
};

const syncWithERP = (idUser: string, config: string, full = false) => {
  initParam();
  param.method = 'get';
  param.idUser = idUser;
  param.lastEndPoint = 'sync';
  param.endUrl = full ? '?full=true' : '';
  param.headers = { config };
  return axiosServerData(param);
};

const getAllProducts = async (idUser: string, config: string) => {
  initParam()
  param.method = 'get'
  param.idUser = idUser
  param.endUrl = '?page=1&limit=10000'
  param.lastEndPoint = 'list'
  param.headers = { config }
  const result = await axiosServerData(param)
  syncWithERP(idUser, config).catch((error) => console.error('Sync with ERP failed:', error))
  return result
}

const exportProductStock = (idUser: string, config: string) => {
  initParam()
  param.method = 'get'
  param.idUser = idUser
  param.endUrl = ''
  param.lastEndPoint = 'stockExport'
  param.headers = { config }
  // @ts-ignore: we override responseType at runtime to get a Blob
  param.responseType = 'blob'
  return axiosServerData(param)
}

export { getProductsByPage, getOneProduct, getAllProducts, exportProductStock, syncWithERP };
